function t(t){return!(!t||!t.__CANCEL__)}export{t as default};
